/**
 * CustomMembershipSignup 컴포넌트 속성 정의
 * 에디터의 속성 패널에서 사용할 속성 그룹 및 컨트롤 정의
 */
const CustomMembershipSignupProperties = [
  {
    group: '기본 설정',
    properties: [
      {
        name: 'componentProps.title',
        label: '제목 (상단 텍스트)',
        control: 'TextField',
        defaultValue: '자유 멤버십 가입',
        description: '컴포넌트 최상단에 표시되는 제목입니다.'
      },
      {
        name: 'componentProps.productId',
        label: '상품 ID',
        control: 'TextField',
        type: 'number',
        defaultValue: 0
      },
      {
        name: 'componentProps.description',
        label: '설명',
        control: 'TextArea',
        defaultValue: '직접 금액을 입력해 가입/추가 결제할 수 있습니다.'
      },
      {
        name: 'componentProps.buttonText',
        label: '버튼 텍스트',
        control: 'TextField',
        defaultValue: '가입/추가 결제'
      },
      {
        name: 'componentProps.completedText',
        label: '완료 텍스트',
        control: 'TextField',
        defaultValue: '추가 결제가 완료되었습니다.'
      },
      {
        name: 'componentProps.minAmount',
        label: '최소 금액',
        control: 'TextField',
        type: 'number',
        defaultValue: 10000
      }
    ]
  },
  {
    group: '자산 설정',
    properties: [
      {
        name: 'componentProps.assetOptions',
        label: '사용 가능한 자산',
        control: 'TextField',
        defaultValue: [],
        description: '사용 가능한 자산 ID 목록 (예: [1, 2, 3])'
      }
    ]
  },
  {
    group: '환급 시각화',
    properties: [
      {
        name: 'componentProps.showRefundVisualization',
        label: '환급 시각화 표시',
        control: 'ToggleSwitch',
        defaultValue: true
      },
      {
        name: 'componentProps.refundLimitPercent',
        label: '환급 한도 퍼센트',
        control: 'TextField',
        type: 'number',
        defaultValue: 400
      },
      {
        name: 'componentProps.allowRejoin',
        label: '재가입 허용',
        control: 'ToggleSwitch',
        defaultValue: true,
        description: '기존 결제 내역이 있는 사용자의 재가입 허용 여부를 설정합니다.'
      }
    ]
  },
  {
    group: '스타일',
    properties: [
      {
        name: 'style.backgroundColor',
        label: '배경색',
        control: 'ColorPicker',
        defaultValue: '#ffffff'
      },
      {
        name: 'style.padding',
        label: '여백',
        control: 'TextField',
        defaultValue: '20px'
      },
      {
        name: 'style.borderRadius',
        label: '테두리 둥글기',
        control: 'TextField',
        defaultValue: '8px'
      },
      {
        name: 'style.boxShadow',
        label: '그림자',
        control: 'TextField',
        defaultValue: '0 2px 10px rgba(0, 0, 0, 0.1)'
      }
    ]
  }
];

export default CustomMembershipSignupProperties; 